import { useOnboardingStoreV2 } from '@forwardflow/store/onboardingStoreV2'
import { UserService } from '@forwardflow/services/UserService'

/**
 * What the agent's last step does when "Start using Forward Flow" is pressed.
 *
 * Extracted from `GettingStarted` unchanged, so it can be TESTED. It is the
 * only place an agent is marked finished, the mark is keyed by the signed-in
 * address, and the address comes out of the store — a record replacement that
 * dropped it therefore sent the agent to the dashboard still unfinished, to
 * be routed back into onboarding. Nothing said so: the button redirects
 * either way.
 *
 *   'recorded'    — the backend was told, for this address.
 *   'no-identity' — nothing was told, because there was no address.
 *
 * The silent redirect on 'no-identity' is existing behaviour and is left
 * alone; the status exists so the condition is observable rather than
 * invisible.
 */
export type AgentCompletion = 'recorded' | 'no-identity'

export const completeAgentOnboarding = async (): Promise<AgentCompletion> => {
   const { email } = useOnboardingStoreV2.getState().onboardingData
   if (!email) {
      return 'no-identity'
   }
   await UserService.completeAgentOnboarding(email)
   return 'recorded'
}
